import SKIP_WORDS from './nameArticles.json';

export const changeDateFormatToMMDDYY = (date) => {
    if (date) {
      const [year, month, day] = date.split('-');
      return (`${month}/${day}/${year}`);
    }
  };

export const getDisplayName = (fullName) => {
  if (!fullName) return '';
  const words = fullName.trim().split(/\s+/);
  if (words.length > 1 && SKIP_WORDS.includes(words[0].toLowerCase())) return fullName.trim();
  return words[0];
};
